import { render, staticRenderFns } from "./casting-calls-detail.vue?vue&type=template&id=65883170&scoped=true&"
import script from "./casting-calls-detail.vue?vue&type=script&lang=ts&"
export * from "./casting-calls-detail.vue?vue&type=script&lang=ts&"
import style0 from "./casting-calls-detail.vue?vue&type=style&index=0&id=65883170&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65883170",
  null
  
)

export default component.exports